import { BrowserRouter } from "react-router-dom";
import Settings from './containers/Settings';
import { installBackCameraPatch } from './utils/backCameraPatch';

installBackCameraPatch();

function App() {
  return (
    <BrowserRouter>
        <Settings />
    </BrowserRouter>
  );
}

export default App;